import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { CForm, CFormLabel, CFormInput, CButton, CListGroup, CListGroupItem, CFormCheck } from '@coreui/react';
import AxiosInstance from 'src/components/Axios';
import { confirmAlert } from 'react-confirm-alert';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import AsyncSelect from 'react-select/async';
import JobsSpecialMachinesModal from './JobsSpecialMachinesModal';
dayjs.extend(utc);



// Компонент для спецтехніки (jobs)
const JobSpecialMachines = (props) => {
    // console.log('props JobSpecialMachines', props);


    const urlApi = '/special_machineries';
    const urlApi_jobs = '/jobs';
    const utcNow = dayjs().toISOString()

    const controllerRefforLoadSpecialMachines = useRef(null);

    const [addedSpecialMachinesIRI, setAddedSpecialMachinesIRI] = useState([]);
    const [specialMachinesIRIToApi, setSpecialMachinesIRIToApi] = useState([]);
    const [addedSpecialMachinesIds, setAddedSpecialMachinesIds] = useState([]);
    const addedSpecialMachinesIdsRef = useRef(addedSpecialMachinesIds);
    const [forceUpdate, setForceUpdate] = useState(0); // Додано примусовий ререндер AsyncSelect

    //стани для працівників
    // const [workerList, setWorkerList] = useState([])
    const [workerList, setWorkerList] = useState(props.jobWorkers ? props.jobWorkers.map(jobWorker => (
        {
            label: jobWorker.worker.fullName,
            value: jobWorker.worker.id
        }
    )) : []);
    const [worker, setWorker] = useState({});//водіі
    //стан для specialMachineriesJobs
    const [specialMachineriesJobs, setSpecialMachineriesJobs] = useState([])
    //стан для відкриття модального вікна
    const [modalShow, setModalShow] = useState(false);
    //стан для вибору спецмашини ,яка буде передаватись в модальне вікно
    const [selectedMachineId, setSelectedMachineId] = useState(null);


    // Для коректного відфільтровування спецтехніки, яка доступна для вибору
    useEffect(() => {
        addedSpecialMachinesIdsRef.current = addedSpecialMachinesIds;
        setForceUpdate(prev => prev + 1); // Примусово оновлюємо Select
    }, [addedSpecialMachinesIds]);


    const [jobSpecialMachines, setJobSpecialMachines] = useState([]); // Спецтехніка, яка додана до роботи
    // console.log('worker', worker)
    // console.log('jobSpecialMachines', jobSpecialMachines)
    // console.log('workerList', workerList)
    // console.log('specialMachinieryJobs', specialMachineriesJobs)
    // Заповнити допоміжні масиви з доданою технікою
    useEffect(() => {
        if (jobSpecialMachines.length > 0) {
            setAddedSpecialMachinesIRI(jobSpecialMachines.map((elem) => `/api/special_machineries/${elem.id}`))
            setAddedSpecialMachinesIds(jobSpecialMachines.map((elem) => elem.id));
        } else {
            setAddedSpecialMachinesIRI([]);
            setAddedSpecialMachinesIds([]);
        };
    }, [jobSpecialMachines]);

    const [selectedSpecialMachine, setSelectedSpecialMachine] = useState(null); // Вибрана техніка з селекту

    // Підготувати масив техніки який буде доданий до роботи для відправлення на api
    useEffect(() => {
        if (selectedSpecialMachine) {
            let newMachine = `/api/special_machineries/${selectedSpecialMachine.value}`;
            setSpecialMachinesIRIToApi([...addedSpecialMachinesIRI, newMachine]);
        } else {
            setSpecialMachinesIRIToApi([...addedSpecialMachinesIRI]);
        };
    }, [addedSpecialMachinesIRI, selectedSpecialMachine]);

    const popupTextAddMachineSuccess = "Спецтехніку оновлено";
    const popupTextAddMachineWarning = "Спецтехніку не оновлено";

    //ініціалізація селектів з водіями 
    useEffect(() => {
        if (jobSpecialMachines.length > 0 && workerList.length > 0 && specialMachineriesJobs.length > 0) {
            const initialWorker = {};
            jobSpecialMachines.forEach((machine) => {

                // const workerId = parseInt(machine.driver.split('/').pop());
                const machineId = machine.id
                //  const foundWorker = specialMachineriesJobs.find(job => job.specialMachineries.id === machineId);
                const foundWorker = specialMachineriesJobs.find(job => job.length > 0 && (Number(job[0].specialMachineries.split('/')[3]) === machineId));
                // console.log('foundWorker', foundWorker)
                //треба розгорнути поля worker і jobs в specialMachinieryJobs
                if (foundWorker?.[0]?.worker) {
                    initialWorker[machine.id] = {
                        label: foundWorker[0].worker.fullName,
                        value: foundWorker[0].worker.id
                    }
                    //  label: result.name,
                    //  value: result.id,
                }

            });
            setWorker(initialWorker);
        }
    }, [jobSpecialMachines, workerList, specialMachineriesJobs]);




    // Функція для запиту за доданою спецтехнікою до роботи
    const getAddaSpecialMachines = async () => {
        try {
            const response = await AxiosInstance.get(`${urlApi}?jobs.id=${props.jobId}`,
                { headers: { accept: 'application/json' } });

            // console.log('get data response.data', response.data);
            setJobSpecialMachines(response.data);
            //Зробити запит за specialMachineryJobs для кожної техніки 

            const res = response.data.map(elem => {

                return AxiosInstance.get(`/special_machineries_jobs`, {
                    params: {
                        "specialMachineries.id": elem.id
                    },

                    headers: { accept: 'application/json' }
                }
                );


            })
            Promise.all(res).then(response => {
                setSpecialMachineriesJobs(response.map(r => r.data))
            })

            //////////////////запит за specialMachineryJobs для кожної техніки 
        } catch (error) {
            console.error("Помилка запиту за доданою спецтехнікою", error);
        };
    };

    // Зробити запит за доданою спецтехнікою
    useEffect(() => {
        if (props.jobId) {
            getAddaSpecialMachines();
        };
    }, [props.jobId]);

    // Вибрати техніку з селекту
    const handleChangeSelectedSpecialMachine = (selectedOption) => {
        setSelectedSpecialMachine(selectedOption);
    };

    // Запит за спецтехніками
    const loadOptionsSpecialMachines = async (inputValue) => {
        // Скасувати попередній запит, якщо він ще не завершився
        if (controllerRefforLoadSpecialMachines.current) {
            controllerRefforLoadSpecialMachines.current.abort();
        };

        controllerRefforLoadSpecialMachines.current = new AbortController();
        const { signal } = controllerRefforLoadSpecialMachines.current;

        try {
            const response = await AxiosInstance.get('/special_machineries?name=' + inputValue, {
                headers: { 'accept': 'application/json' },
                signal
            });

            // console.log('response.data', response.data);
            return response.data
                .filter((result) => !addedSpecialMachinesIdsRef.current.includes(result.id))
                .map((result) => ({
                    label: result.name,
                    value: result.id,
                }));
        } catch (error) {
            if (error.name === 'CanceledError') {
                // console.log("Запит скасовано:", error.message);
            } else {
                console.error("Помилка запиту:", error);
            };
            return [];
        };
    };

    // Функція для додавання масиву з технікою до роботи (відправлення на api)
    const handleSave = async (specialMachinesIRIToApi) => {
        try {
            const response = await AxiosInstance.put(`${urlApi_jobs}/${props.jobId}`, {
                specialMachineries: specialMachinesIRIToApi,
                dateModified: utcNow

            });
            setSelectedSpecialMachine(null);
            getAddaSpecialMachines();
            // Повідомлення про успішне додавання працівника
            props.popup.toastifySuccess(popupTextAddMachineSuccess);
        } catch (error) {
            props.popup.toastifyWarning(popupTextAddMachineWarning);
            console.error("Помилка оновлення доданих спецтехнік", error);
        };
    };

    // Функція для додавання нової техніки
    const addMachinesToJob = () => {
        handleSave(specialMachinesIRIToApi);
    };

    // Функція для видалення вже доданої техніки
    const deleteMachineFromJob = (id) => {
        // console.log('addedSpecialMachinesIRI', addedSpecialMachinesIRI);
        let newArr = addedSpecialMachinesIRI.filter(machineIRI => {
            const machineId = parseInt(machineIRI.split('/').pop()); // Отримуємо `id` з IRI
            return machineId !== id; // Залишаємо всі крім того, що потрібно видалити
        });
        // console.log('newArr', newArr);
        handleSave(newArr);
    };

    // Запит за працівниками у вибраного контрагента
    const getWorkersList = async (totalItems) => {
        let rez = await AxiosInstance.get(`/workers?pagination=false&accountWorkers.account.id=${props.data?.account.id}`, {
            headers: { accept: 'application/json' },
        }).then((response) => {
            // console.log('response workers get', response);
            return response.data.map((result) => ({

                label: result.fullName,
                value: result.id,
            }))
        });
        setWorkerList(rez)
    };


    // Створення або зміна вже існуючого specialMachineryJobs при додаванні працівника в селекті поля спеціальноі техніки

    const addtWorkerToMachine = async (machine, machineId, workerId, jobsId) => {
        const existing = specialMachineriesJobs.find(elem =>
            elem.length > 0 &&
            Number(elem[0].specialMachineries?.split('/')[3]) === machineId &&
            Number(elem[0].jobs?.id) === jobsId
        );
        // console.log(machineId, 'machineId'),
        //     console.log(workerId, 'workerId')
        // if (!specialMachineriesJobs.find(elem => elem.length > 0 && (Number(elem[0].specialMachineries.split('/')[3]) === machineId) && (Number(elem[0].jobs.id) === jobsId))) {
        if (!existing) {
            console.log('post запит')
            await AxiosInstance.post(`/special_machineries_jobs`,
                {
                    worker: `/api/workers/${workerId}`,
                    specialMachineries: `/api/special_machineries/${machineId}`,
                    jobs: `/api/jobs/${jobsId}`,
                },
                {
                    headers: { accept: 'application/json' },
                }).then((response) => {
                    console.log('response workers get', response);
                    getAddaSpecialMachines();
                    return response.data
                }).catch(error => {
                    console.error('Error occurred:', error.response ? error.response.data : error.message);
                });

        } else {
            console.log('put запит')
            await AxiosInstance.put(`/special_machineries_jobs/${existing[0].id}`,
                {
                    worker: `/api/workers/${workerId}`,
                },
                {
                    headers: { accept: 'application/json' },
                }).then((response) => {
                    console.log('response workers get', response);
                    getAddaSpecialMachines();
                    return response.data
                });

        };
    }

    // Фунція для відкривання модального вікна з підтвердженням на видалення техніки
    function Deleted(row) {
        confirmAlert({
            title: 'Увага!',
            message: `Ви впевнені що хочите видалити "${row.name}" з роботи?`,
            buttons: [
                {
                    label: 'Так',
                    onClick: () => {
                        // console.log('row.id', row.id);
                        deleteMachineFromJob(row.id);
                    },
                },
                {
                    label: 'Ні',
                    onClick: () => {
                        return
                    },
                },
            ],
        })
    }

    // useEffect(() => {
    //     getWorkersList()
    // }, [])

    useEffect(() => {
        setWorkerList(props.jobWorkers.map(jobWorker => (
            {
                label: jobWorker.worker.fullName,
                value: jobWorker.worker.id
            }
        )) || [])
    }, [props.jobWorkers])

    // console.log('jobSpecialMachines', jobSpecialMachines)


    return (
        <>
            {/* <p className="h4">Спецтехніка</p> */}

            {/* props.isDisabledAll={true} - Заблокувати можливу зміну, оскільки дані вже вневені в 1С */}
            {
                !props.isDisabledAll &&
                // <div className="col d-flex justify-content-end">
                <div className="col d-flex mt-3">
                    <AsyncSelect
                        key={forceUpdate} // Оновлюється після зміни масиву
                        cacheOptions
                        loadOptions={loadOptionsSpecialMachines}
                        defaultOptions
                        value={selectedSpecialMachine}
                        onChange={handleChangeSelectedSpecialMachine}
                        className="w-25"
                        isDisabled={props.isDisabledChange}
                        placeholder="Введіть номер та виберіть..."
                    />
                    <CButton onClick={addMachinesToJob} className="ms-3 mb-2" color="secondary"
                        disabled={!selectedSpecialMachine || props.isDisabledChange}
                    >
                        +
                    </CButton>
                </div>
            }

            {
                jobSpecialMachines.length > 0 &&
                <CListGroup className="mb-3">
                    {selectedMachineId && <JobsSpecialMachinesModal
                        show={true}
                        onHide={() => {
                            // setModalShow(false)
                            setSelectedMachineId(null)
                        }}
                        machine={jobSpecialMachines.find(machine => selectedMachineId === machine.id)}
                        jobEnd={props.data.dateEnd}
                    />}
                    {jobSpecialMachines.map((machine) => {
                        // console.log('machine', machine);

                        return (
                            <CListGroupItem key={machine.id} className="d-flex justify-content-between align-items-center">
                                <Link to={`/special-machines/read/${machine.id}`} target='_blank' className="ms-3">
                                    {machine.name}
                                </Link>
                                {/* тип,якщо є */}
                                <div className="col d-flex justify-content-start ms-2">
                                    {machine.type ? machine.type.name : <span style={{ color: 'red' }}>Додайте тип техніки</span>}
                                </div>
                                {/* тип,якщо є */}
                                {/* Блок документів */}
                                {
                                    // (machine.type && machine.type.id !== 1)
                                    machine.dosc.length > 0
                                        ? <div className="col d-flex justify-content-center" style={{ cursor: 'pointer' }} onClick={() => {
                                            // setModalShow(true)
                                            setSelectedMachineId(machine.id)
                                        }}>
                                            Перелік документів.Натисніть щоб розгорнути.

                                        </div> : <span style={{ color: 'red' }}>Відсутній список документів</span>}

                                {/* Блок документів */}
                                {/* Додати селект з працівниками */}
                                <div className="col d-flex justify-content-end me-2">
                                    <Select
                                        options={workerList}
                                        value={worker[machine.id] || null}
                                        onChange={(value) => {
                                            setWorker(prev => ({ ...prev, [machine.id]: value }))
                                            addtWorkerToMachine(machine, machine.id, value.value, props.data.id)
                                        }}
                                        // className="w-25"
                                        isDisabled={props.isDisabledChange}
                                        placeholder="Виберіть..."
                                    />
                                </div>
                                {/* Додати селект з працівниками*/}

                                {
                                    !props.isDisabledAll &&
                                    <CButton color="danger" variant="outline" onClick={() => Deleted(machine)} disabled={props.isDisabledChange}>
                                        Видалити
                                    </CButton>
                                }
                            </CListGroupItem>
                        )
                    })}
                </CListGroup>
            }
        </>
    );
};

export default JobSpecialMachines;